import React from 'react';
import { bonuses } from '../data/content';
import { OFFER_ANCHOR } from '../data/constants';
export function BonusSection() {
  return <section className="bg-sage/25 px-4 py-9 sm:px-6 sm:py-12" data-id="element-20" data-mp="1ofc33n6bufds">
      <div className="mx-auto max-w-6xl" data-id="element-21" data-mp="22fwo8pzpsnag">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.18em] text-sage-dark sm:text-xs" data-id="element-22" data-mp="22etwygyhciu0">
          Également inclus sans frais supplémentaires
        </p>
        <h2 className="mt-1.5 text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-23" data-mp="1ap8q7mtc7y10">
          Cinq bonus stratégiques
        </h2>
        <p className="mt-1.5 text-[13px] text-graphite/80 sm:text-sm" data-id="element-24" data-mp="15n9mgbtoqz3j">
          100% inclus aujourd’hui avec votre système ORTHOPHONIE PRO™.
        </p>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="1eozo0aha7ef1">
          {bonuses.map(bonus => <li key={bonus.label} data-id="element-26" data-mp="qz5bxv4sdtvu">
              <a href={OFFER_ANCHOR} className="flex h-full flex-col overflow-hidden rounded-xl border border-sage/50 bg-white transition-colors duration-150 ease-out hover:border-gold" data-id="element-27" data-mp="qyde0dnpvk2e">
                <img src={bonus.img} alt={bonus.title} className="h-36 w-full bg-cream-dark object-contain object-center p-2 sm:h-40" data-id="element-28" data-mp="2eqo1xbrw84yk" />
                <div className="flex flex-1 flex-col p-4" data-id="element-29" data-mp="2oh8ykto0azeu">
                  <span className="w-fit rounded-full bg-gold px-2 py-0.5 font-display text-[10px] font-extrabold uppercase tracking-widest text-petrol-dark" data-id="element-30" data-mp="2oittwli5amdr">
                    {bonus.label}
                  </span>
                  <h3 className="mt-2 text-[14px] font-extrabold leading-tight sm:text-base" data-id="element-31" data-mp="20roeg7g49w3z">
                    {bonus.title}
                  </h3>
                  {bonus.paragraphs.map(text => <p key={text} className="mt-1.5 text-[13px] leading-snug text-graphite/80" data-id="element-32" data-mp="3c6ttmaxfpn4h">
                      {text}
                    </p>)}
                  <ul className="mt-auto flex flex-wrap gap-1.5 pt-3" data-id="element-33" data-mp="3h7ra8j2sq93v">
                    {bonus.tags.map(tag => <li key={tag} className="rounded-full bg-cream-dark px-2 py-0.5 text-[10px] font-semibold text-petrol" data-id="element-34" data-mp="1c4arat1zf1co">
                        {tag}
                      </li>)}
                  </ul>
                </div>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}